const stepperPalette = (tokens) => {
    return {
        spaceBetween: tokens.stepperSpaceBetween,
        padding: tokens.stepperPadding
    };
};
export default stepperPalette;
//# sourceMappingURL=stepper.js.map